const quizOmissionReasons = {
  INTENTIONALLY_OMITTED: "INTENTIONALLY_OMITTED",
  QUIZ_COMING_SOON: "QUIZ_COMING_SOON",
};

export default quizOmissionReasons;
